import React from 'react'
import { connect } from 'react-redux'
import View from './View'
import { getInnovateIdeaTemplateIdJson, getInitialInnovateIdeaDraft, postInnovateCreateIdeaDraft, postInnovateCreateIdeaPublish, postInnovateCreateIdeaEdit } from 'services/innovate/idea'
// import { postIdeaDocument,deleteIdeaDocument } from 'services/create_idea'
import { getBase64Split } from 'support/utils/file'

import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SuccessSubmitModal from './dialogs/SucessSubmitContainer'
import ConfirmSubmitModal from './dialogs/ConfirmSubmitContainer'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { MAX_SIZE_DOCUMENT } from 'common_constants/Ideas'
import { getIdeaInnovateDetail, deleteInnovateIdeaDocument, postInnovateIdeaDocument, deleteInnovateIdeaImage, postInnovateIdeaImage } from 'services/innovate/idea'



const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,

  getInnovateIdeaIdDetailIsLoading: state.data.InnovateIdea.getInnovateIdeaIdDetailIsLoading,
  getInnovateIdeaIdDetail: state.data.InnovateIdea.getInnovateIdeaIdDetail,

  getInnovateIdeaTemplateIdJsonLoading: state.data.InnovateIdea.getInnovateIdeaTemplateIdJsonLoading,
  getInnovateIdeaTemplateIdJson: state.data.InnovateIdea.getInnovateIdeaTemplateIdJson,

  getInnovateIdeaDraftID: state.data.InnovateIdea.getInnovateIdeaDraftID,
  getInnovateCreateIdeaDraftData: state.data.InnovateIdea.getInnovateCreateIdeaDraftData,
  getInnovateCreateIdeaDraftLoading: state.data.InnovateIdea.getInnovateCreateIdeaDraftLoading,
  getInnovateIdeaDocumentUploadLoading: state.data.InnovateIdea.getInnovateIdeaDocumentUploadLoading,
  deleteInnovateIdeaDocumentLoading: state.data.InnovateIdea.deleteInnovateIdeaDocumentLoading,
  getInnovateIdeaDocumentUpload: state.data.InnovateIdea.getInnovateIdeaDocumentUpload,
  deleteInnovateIdeaDocument: state.data.InnovateIdea.deleteInnovateIdeaDocument,
  getInnovateIdeaImageLoading: state.data.InnovateIdea.getInnovateIdeaImageLoading,
  getInnovateIdeaImageDeleteLoading: state.data.InnovateIdea.getInnovateIdeaImageDeleteLoading,
  getInnovateCreateIdeaEditLoading: state.data.InnovateIdea.getInnovateCreateIdeaEditLoading,
  getInnovateIdeaImage: state.data.InnovateIdea.getInnovateIdeaImage,

  InnovateIdeaStatus: state.data?.InnovateIdea?.getInnovateIdeaIdDetail?.status,

  isAdmin: state.data.user.admin,
  isInnovator: state.data.user.isInnovator,
  isEvaluator: state.data.user.evaluator,
  // isOwnerInnovate: state.data.InnovateIdea.getInnovateIdeaIdDetail.idea.owner === state.data.user.userEmail,
  isOwner: state.data.createIdea.owner === state.data.user.userEmail,
  csrf: state.auth.csrf,

})

const mapDispatchToProps = dispatch => {
  return {

    getIdeaInnovateDetailFn: (id) => {
      dispatch(getIdeaInnovateDetail(id))
    },
    getInnovateIdeaTemplateIdJsonFn: (idIdeaTemplate) => {
      dispatch(getInnovateIdeaTemplateIdJson(idIdeaTemplate))
    },
    postInnovateCreateIdeaDraftFn: (idIdeaTemplate) => {
      dispatch(postInnovateCreateIdeaDraft(idIdeaTemplate))
    },
    postInnovateCreateIdeaPublishFn: (idIdeaTemplate) => {
      // dispatch(postInnovateCreateIdeaPublish(idIdeaTemplate))
      showPopupDialog(<ConfirmSubmitModal createInnovateIdeaData={idIdeaTemplate} />, dispatch)
    },
    postInnovateCreateIdeaEditFn: (idIdeaTemplate) => {
      const onSuccess = () => {
        showPopupSuccessSnackbar('Your idea updated Successfully!', dispatch)
        dispatch(hideDialog())
        Navigation.navigateBack()
      }
      const onFailure = errorResponse => {
        const { data } = errorResponse
        if (data && data.error && data.error.status === 400 && data.error.code === 2003) {
          showPopupErrorSnackbar('get error!', dispatch)
        } else {
          showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
        }
      }
      dispatch(postInnovateCreateIdeaEdit(idIdeaTemplate, onSuccess, onFailure))
    },


    onDocumentUpload: (id, file, documentKey) => {
      const onSuccess = () => {
        showPopupSuccessSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_COMPLETE'), dispatch)
        dispatch(hideDialog())
      }
      const onFailure = error => {
        if (error.status === 413) {
          showPopupErrorSnackbar(
            i18n.t('EXPLORE_IDEA.UPLOAD_MAX_SIZE_DOC_ERROR', { max_size: MAX_SIZE_DOCUMENT }),
            dispatch,
          )
        } else {
          showPopupErrorSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_ERROR'), dispatch)
        }
        dispatch(hideDialog())
      }
      getBase64Split(
        file,
        (fileName, base64File) => {
          dispatch(postInnovateIdeaDocument(id, fileName, documentKey, base64File, onSuccess, onFailure))
        },
        true,
      )
    },
    onDocumentDelete: (id, documentId) => {
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('EXPLORE_IDEA.DELETE_KO'), dispatch)
      }
      dispatch(deleteInnovateIdeaDocument(id, documentId, onFailure))
    },


    postInnovateIdeaImageFn: (IdKeyForImage, imageName) => {
      const onSuccess = () => { }
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
      }
      dispatch(postInnovateIdeaImage(IdKeyForImage, imageName, onSuccess, onFailure))
    },
    deleteImageFn: (ideaID, imageName) => {
      const onFailure = errorResponse => {
        const { data } = errorResponse
        if (data && data.error && data.error.status === 400 && data.error.code === 2003) {
          showPopupErrorSnackbar(i18n.t('CHALLENGES.DELETE_IMAGE_ERROR'), dispatch)
        } else {
          showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
        }
      }
      dispatch(deleteInnovateIdeaImage(ideaID, imageName, onFailure))
    },
    navigateToAccessDenied: () => dispatch(Navigation.navigateToAccessDenied)

  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
